import { colors } from './colors';

const fontSmoothing = `
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
`;

const fontFamily = "font-family: 'Avenir Web', Avenir, Helvetica, Arial, sans-serif;";

/**
 * Return the font closure
 */
const avenir = (weight: number) => () =>
  `${fontSmoothing}
  ${fontFamily}
  font-synthesis: style;
  font-weight: ${weight};
`;

// Keep weights synchronized with https://static.bombbomb.com/fonts/avenir.css!

/**
 * Avenir weight 100 - 200
 * @deprecated
 */
const light = avenir(200);

/**
 * Avenir weight 300
 * @deprecated
 */
const book = avenir(300);

/**
 * Avenir weight 400
 * @deprecated
 */
const roman = avenir(400);

/**
 * Avenir weight 500
 * @deprecated
 */
const medium = avenir(500);

/**
 * Avenir weight 600-700
 * @deprecated
 */
const heavy = avenir(700);

/**
 * Avenir weight 800-900
 * @deprecated
 */
const black = avenir(900);

/**
 * @deprecated
 */
const h1 = () => `
  ${heavy()}
  font-size: 2.375rem;
  color: ${colors.battleship};
`;

/**
 * @deprecated
 */
const h2 = () => `
${heavy()}
font-size: 1.75rem;
color: ${colors.battleship};
`;

/**
 * @deprecated
 */
const h3 = () => `
${medium()}
font-size: 1.375rem;
color: ${colors.boulder};
`;

/**
 * @deprecated
 */
const h4 = () => `
${medium()}
font-size: 1.25rem;
color: ${colors.boulder};
`;

/**
 * @deprecated
 */
const h5 = () => `
${medium()}
font-size: 1.125rem;
color: ${colors.boulder};
`;

/**
 * @deprecated
 */
const h6 = () => `
${medium()}
font-size: 1rem;
color: ${colors.boulder};
`;

/**
 * @deprecated
 */
const h7 = () => `
${medium()}
font-size: 0.875rem;
color: ${colors.boulder};
`;

/**
 * @deprecated
 */
const body1 = () => `
${book()}
font-size: 1.125rem;
color: ${colors.boulder};
`;

/**
 * @deprecated
 */
const body2 = () => `
${book()}
font-size: 1rem;
color: ${colors.boulder};
`;

export { heavy, light, book, black, roman, medium, h1, h2, h3, h4, h5, h6, h7, body1, body2 };
